import React from 'react';
import { ErrorMessage } from '../Error';
import Checkbox from '@material-ui/core/Checkbox';
import styles from './index.css';
import PropTypes from 'prop-types';

export const SignerValidation=(props)=>{

    const isSignerValidationError = props.showMandatoryFieldsError === 'invisible' && props.showDuplicationError === 'invisible'
        && props.showDuplicateEmailMobileError === 'invisible';
    const checkboxHidden = props.showDuplicateEmailMobileError === 'invisible'  || (props.countryCode !== 'ES' && props.countryCode !== 'PT');
    const displayComplianceError = props.showDuplicateEmailMobileError === 'visible' && (props.countryCode === 'ES' || props.countryCode === 'PT');

    return (
        !isSignerValidationError &&
            (<div>
                <Checkbox className={styles.cbCheckbox} hidden={checkboxHidden} onChange={() => props.handleCBCheckBox()}
                />
                <span className="d-flex ml-auto mb-2">
                    <ErrorMessage cssFlag={true} message={props.errorMessage} showIcon={true} />
                </span>
                {displayComplianceError &&
                    <span className="d-flex ml-auto mb-2">
                        <ErrorMessage
                            cssFlag={true} message={props.errorMessageCompliance} showIcon={true} />
                    </span>
                }
            </div>)

    )
};


SignerValidation.propTypes = {
    showMandatoryFieldsError: PropTypes.bool.isRequired,
    showDuplicationError: PropTypes.bool.isRequired,
    showDuplicateEmailMobileError: PropTypes.bool.isRequired,
    countryCode: PropTypes.string.isRequired,
    errorMessage: PropTypes.object.isRequired,
    errorMessageCompliance: PropTypes.object.isRequired
}

